import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';

import { AuthService } from './auth.service';

export const adminGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const redirectToLogin = () => router.createUrlTree(['/login']);
  const decide = () => auth.canEnterAdmin() ? true : redirectToLogin();

  if (!auth.isAuthenticated()) {
    return redirectToLogin();
  }

  if (auth.permissionsReady()) {
    return decide();
  }

  return auth.restoreSession().pipe(
    map(decide),
    catchError(() => of(redirectToLogin())),
  );
};
